import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLocationArrow,
  faLocationDot,
} from '@fortawesome/pro-regular-svg-icons';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { Text } from '@querodelivery/uni-react';
import type { ReactNode } from 'react';
import type { ENUM_DELIVERY_TYPE } from '@/_features/deliveries/constants';
import { DeliveryTags } from '../../../delivery-tags/delivery-tags';
import styles from './drawer-header.module.scss';

interface DrawerHeaderProps {
  code?: string;
  cityName?: string;
  deliveryType?: ENUM_DELIVERY_TYPE;
  actions?: ReactNode;
  onClose: () => void;
}

export function DrawerHeader({
  code,
  cityName,
  deliveryType,
  actions,
  onClose,
}: DrawerHeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.titleRow}>
        <Text
          as="h2"
          fontSize="md"
          fontWeight="bold"
          lineHeight="lg"
          tone="supporting"
        >
          Mapa ao vivo
        </Text>
        <div className={styles.actions}>
          {actions}
          <button
            type="button"
            className={styles.closeButton}
            aria-label="Fechar detalhe da entrega"
            onClick={onClose}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
      </div>

      {(code || cityName) && (
        <div className={styles.infoBox}>
          <span className={styles.identifiers}>
            {code && (
              <span className={styles.codeChip}>
                <FontAwesomeIcon
                  icon={faLocationArrow}
                  className={styles.icon}
                />
                <Text
                  as="span"
                  fontSize="xs"
                  fontWeight="medium"
                  lineHeight="lg"
                  tone="highlight"
                >
                  #{code}
                </Text>
              </span>
            )}
            <DeliveryTags deliveryType={deliveryType} />
          </span>
          {cityName && (
            <span className={styles.city}>
              <FontAwesomeIcon icon={faLocationDot} className={styles.icon} />
              <Text
                as="span"
                fontSize="sm"
                fontWeight="medium"
                lineHeight="lg"
                tone="supporting"
                truncate
              >
                {cityName}
              </Text>
            </span>
          )}
        </div>
      )}
    </header>
  );
}
